import { useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { parseLoginOtpFragmentParams } from "../../lib/auth/loginOtpNavigationState";

export default function useLoginOtpFragmentHash() {
  const { hash: hashFragment, pathname, search, state } = useLocation();
  const history = useHistory();
  const fragmentParamsRef = useRef(null);

  if (fragmentParamsRef.current === null) {
    fragmentParamsRef.current = parseLoginOtpFragmentParams(hashFragment);
  }

  useEffect(() => {
    if (!hashFragment) {
      return;
    }

    history.replace({ pathname, search, state });
  }, [hashFragment, history, pathname, search, state]);

  return fragmentParamsRef.current;
}
